export default __webpack_public_path__ + "static/media/Avenir-Regular.61084be9.woff2";